module.exports = __webpack_public_path__ + "media/images/telemedicine-d08c8e00f4ff1ad9a4863134c24f960e.png";